import Header from "../components/Header"
import Footer from "../components/Footer"

export default function InvalidID(props) {
    return (
        <>
            <Header />
            <div className="pt-20 h-screen backdrop-blur-xl bg-gradient-to-t from-[#070E25] to-black">
                <div className="items-center w-full justify-center flex pt-8">
                    <p className="text-blue-500 text-[13rem] font-extrabold">404</p>
                </div>
                <div className="pt-18 flex flex-col w-full items-center justify-center">
                    <p className="text-5xl font-bold text-blue-300 text-center">Sorry, the invite you're trying to access is either expired or invalid.</p>
                    <p className="text-3xl font-semibold text-blue-300 pt-12">Please try again or contact <a href="mailto:support@entropi.app">support@entropi.app</a> for assistance</p>
                </div>
                <Footer />
            </div>
        </>
    )
}